import type { JSX } from 'react'
import { useStoreMap } from 'effector-react'
import { appearanceFeature } from '~/features/appearance'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title({ identifier }: { identifier: string }): JSX.Element {
  const mod = useStoreMap({
    store: appearanceFeature.$modules,
    keys: [identifier],
    fn: (modules) => modules?.find((m) => m.identifier === identifier) ?? null,
  })
  return <AppTitle>{mod?.title || 'Not found'}</AppTitle>
}
